import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const DeleteColumn = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 5.5V7.5H14V5.5H12ZM11 7.5V8.5V10.5V11.5V13.5C11 14.0523 11.4477 14.5 12 14.5H14C14.5523 14.5 15 14.0523 15 13.5V11.5V10.5V8.5V7.5V5.5V4.5V2.5C15 1.94772 14.5523 1.5 14 1.5H12C11.4477 1.5 11 1.94771 11 2.5L11 4.5V5.5V7.5ZM14 10.5V8.5H12V10.5H14ZM12 11.5V13.5H14V11.5H12ZM12 4.5L14 4.5V2.5L12 2.5V4.5ZM7.40806 6.53119H6.90806H2.96936H2.46936H2.46112L2.92283 11.1742C2.94826 11.43 3.16339 11.6248 3.42037 11.6248H6.45702C6.714 11.6248 6.92913 11.43 6.95456 11.1742L7.41628 6.53119H7.40806ZM7.40806 5V5.53119H7.96846H8.87739C9.15353 5.53119 9.37739 5.75505 9.37739 6.03119C9.37739 6.30733 9.15353 6.53119 8.87739 6.53119H8.42121L7.94966 11.2732C7.87337 12.0404 7.22796 12.6248 6.45702 12.6248H3.42037C2.64943 12.6248 2.00402 12.0404 1.92774 11.2732L1.45618 6.53119H1C0.723858 6.53119 0.5 6.30733 0.5 6.03119C0.5 5.75505 0.723858 5.53119 1 5.53119H1.90893H2.46936V5C2.46936 4.17157 3.14093 3.5 3.96936 3.5H5.90806C6.73648 3.5 7.40806 4.17157 7.40806 5ZM3.46936 5.53119V5C3.46936 4.72386 3.69322 4.5 3.96936 4.5H5.90806C6.1842 4.5 6.40806 4.72386 6.40806 5V5.53119H3.46936Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default DeleteColumn
